<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list'" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-bookmarks me-2 text-primary"></i>Books List</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="refreshList()" [disabled]="isListLoading" title="Reload list">
            <i class="pe-7s-refresh me-1"></i>Refresh
          </button>
          <button type="button" class="btn btn-sm btn-pdf" (click)="openCatalogue()" title="Generate book catalogue PDF">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
            Catalogue PDF
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New Book
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">
        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted mb-1">
            {{ loadProgress.total ? ('Loading books… ' + loadProgress.loaded.toLocaleString() + ' of ' + loadProgress.total.toLocaleString()) : 'Loading books…' }}
          </p>
          <div class="progress mx-auto" style="max-width:320px;height:6px;" *ngIf="loadProgress.total">
            <div class="progress-bar" role="progressbar"
                 [style.width.%]="(loadProgress.loaded / loadProgress.total) * 100"></div>
          </div>
          <p class="mt-2 text-warning small mb-0" *ngIf="loadSlow">
            <i class="pe-7s-attention me-1"></i>Your connection looks slow — this may take a bit longer than usual.
          </p>
        </div>
        <div class="alert alert-danger m-3 d-flex align-items-center justify-content-between" *ngIf="!isListLoading && loadError">
          <span><i class="pe-7s-attention me-1"></i>{{ loadError }}</span>
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="loadList()">Retry</button>
        </div>
        <vio-table-v2 *ngIf="!isListLoading && !loadError" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">

    <div class="text-center py-5" *ngIf="isFormLoading">
      <div class="spinner-border text-primary"></div>
      <p class="mt-2 text-muted">Loading book details...</p>
    </div>

    <div class="alert alert-danger m-3" *ngIf="!isFormLoading && editLoadError">
      <i class="pe-7s-attention me-1"></i>{{ editLoadError }}
      <button type="button" class="btn btn-sm btn-outline-danger ms-3" (click)="backToList()">Back to List</button>
    </div>

    <div class="bb-form-card" *ngIf="!isFormLoading && !editLoadError">
      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-bookmarks"></i>
          {{ isEditMode ? 'Edit Book' : 'New Book' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> Back
        </button>
      </div>
      <app-book-form [editBook]="pendingEditBook" (saved)="onBookSaved($event)"></app-book-form>
    </div>

  </div>

</div>

<!-- ── Add Copy Modal ─────────────────────────────────────────────────────── -->
<div class="bm-ac-backdrop" *ngIf="showAddCopyModal" (click)="closeAddCopyModal()"></div>
<div class="bm-ac-modal" *ngIf="showAddCopyModal" (click)="$event.stopPropagation()">

  <div class="bm-ac-header">
    <div class="bm-ac-title"><i class="pe-7s-plus me-2 text-primary"></i>Add Copies</div>
    <button type="button" class="bm-ac-close" (click)="closeAddCopyModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="bm-ac-book-strip">
    <div class="bm-ac-book-icon"><i class="pe-7s-notebook"></i></div>
    <div class="bm-ac-book-name">{{ addCopyBook?.bookName }}</div>
    <span class="bm-ac-book-id" *ngIf="addCopyBook?.bookId">{{ addCopyBook.bookId }}</span>
  </div>

  <!-- ── Step 1: Form ── -->
  <div class="bm-ac-body" *ngIf="addCopyStep === 'form'">

    <div class="bm-ac-field">
      <label class="bm-ac-label">Number of Copies</label>
      <input type="number" class="form-control form-control-sm" style="max-width:120px;"
             min="1" max="200" [(ngModel)]="addCopyCopies">
    </div>

    <div class="bm-ac-field mt-3">
      <label class="bm-ac-label">Copy Location <span class="text-muted fw-normal">(optional)</span></label>
      <input type="text" class="form-control form-control-sm" style="max-width:320px;"
             placeholder="e.g. Shelf A3, Rack 2…" [(ngModel)]="addCopyLocation" maxlength="100">
    </div>

    <div class="bm-ac-field mt-3">
      <label class="bm-ac-label">Center</label>
      <!-- Manager: show assigned center as read-only text -->
      <div *ngIf="isManagerRole" class="form-control-plaintext form-control-sm ps-0 fw-semibold"
           style="max-width:320px;">
        {{ addCopySelectedCenter?.centerName || 'No center assigned' }}
      </div>
      <!-- Admin: dropdown with first center pre-selected -->
      <ng-container *ngIf="!isManagerRole">
        <div *ngIf="centersLoading" class="text-muted small">
          <span class="spinner-border spinner-border-sm me-1"></span>Loading centers…
        </div>
        <select class="form-select form-select-sm" style="max-width:320px;"
                *ngIf="!centersLoading" [(ngModel)]="addCopyCenterId">
          <option value="">— Select center —</option>
          <option *ngFor="let c of centers" [value]="c._id">{{ c.centerName }}</option>
        </select>
      </ng-container>
    </div>

    <div class="alert alert-danger py-2 px-3 small mt-3" *ngIf="addCopyError">
      <i class="pe-7s-attention me-1"></i>{{ addCopyError }}
    </div>

    <div class="bm-ac-footer mt-4">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeAddCopyModal()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary btn-sm"
              (click)="createCopies()" [disabled]="addCopyIsCreating">
        <span *ngIf="addCopyIsCreating" class="spinner-border spinner-border-sm me-1"></span>
        <i *ngIf="!addCopyIsCreating" class="pe-7s-diskette me-1"></i>
        {{ addCopyIsCreating ? 'Creating…' : 'Create' }}
      </button>
    </div>
  </div>

  <!-- ── Step 2: Result ── -->
  <div class="bm-ac-body" *ngIf="addCopyStep === 'result'">

    <div class="bm-ac-success">
      <i class="pe-7s-check bm-ac-success-icon"></i>
      <div class="bm-ac-success-text">
        {{ addCopyGeneratedSrNos.length }} cop{{ addCopyGeneratedSrNos.length === 1 ? 'y' : 'ies' }} created successfully!
      </div>
    </div>

    <div class="bm-ac-srnos">
      <div class="bm-ac-srnos-label">Assigned Sr. Numbers:</div>
      <div class="bm-ac-srnos-list">
        <span *ngFor="let n of addCopyGeneratedSrNos" class="bm-ac-srno-chip">
          {{ padSrNo(n) }}
        </span>
      </div>
    </div>

    <div class="bm-ac-print-ask">Print barcode labels?</div>
    <div class="bm-ac-footer mt-2">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeAddCopyModal()">
        No
      </button>
      <button type="button" class="btn btn-primary btn-sm" (click)="printAndClose()">
        <i class="pe-7s-print me-1"></i>Yes, Print
      </button>
    </div>

  </div>
</div>

<!-- ── Author Books Panel ─────────────────────────────────────────────────── -->
<div class="bm-hl-backdrop" *ngIf="showAuthorPanel" (click)="closeAuthorPanel()"></div>
<div class="bm-hl-panel" *ngIf="showAuthorPanel" (click)="$event.stopPropagation()">

  <div class="bm-hl-header">
    <div class="bm-hl-title">
      <i class="pe-7s-bookmarks me-2 text-primary"></i>{{ authorPanelTitle }}
    </div>
    <button type="button" class="bm-hl-close" (click)="closeAuthorPanel()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="bm-hl-body">

    <div class="text-center py-4" *ngIf="isAuthorPanelLoading">
      <div class="spinner-border text-primary spinner-border-sm"></div>
      <p class="text-muted small mt-2">Loading books…</p>
    </div>

    <div class="alert alert-danger py-2 px-3 small m-3" *ngIf="authorPanelError">
      <i class="pe-7s-attention me-1"></i>{{ authorPanelError }}
    </div>

    <div class="bm-hl-empty" *ngIf="!isAuthorPanelLoading && !authorPanelError && authorPanelBooks.length === 0">
      <i class="pe-7s-bookmarks bm-hl-empty-icon"></i>
      <p>No books found.</p>
    </div>

    <div *ngIf="!isAuthorPanelLoading && authorPanelBooks.length > 0">
      <p class="bm-hl-meta">{{ authorPanelBooks.length }} title(s) — click View Copies to see locations</p>
      <div class="bm-hl-book-card" *ngFor="let book of authorPanelBooks">
        <div class="bm-hl-book-header">
          <div class="bm-hl-book-icon"><i class="pe-7s-notebook"></i></div>
          <div class="bm-hl-book-info">
            <div class="bm-hl-book-name">{{ book.bookName }}</div>
            <div class="bm-hl-book-meta">
              <span class="bm-hl-code" *ngIf="book.bookId">{{ book.bookId }}</span>
            </div>
          </div>
          <div class="bm-hl-stats">
            <span class="bm-hl-stat bm-hl-stat-c" title="At Center">⌂ {{ book.available }}</span>
            <span class="bm-hl-stat bm-hl-stat-m" title="Issued">⇌ {{ book.issued }}</span>
          </div>
          <button class="bm-hl-view-btn" (click)="openBookCopies(book)">
            <i class="pe-7s-map-marker me-1"></i> View Copies
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- ── Copies Modal (stacks over author panel) ─────────────────────────────── -->
<div class="bm-hl-copies-bd" *ngIf="showCopiesModal" (click)="closeCopiesModal()"></div>
<div class="bm-hl-copies-modal" *ngIf="showCopiesModal" (click)="$event.stopPropagation()">

  <div class="bm-hl-cm-header">
    <div class="bm-hl-cm-title">
      <i class="pe-7s-map-marker me-2 text-primary"></i>Copy Locations
    </div>
    <button type="button" class="bm-hl-close" (click)="closeCopiesModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="bm-hl-cm-book-strip">
    <div class="bm-hl-cm-book-icon"><i class="pe-7s-notebook"></i></div>
    <div class="bm-hl-cm-book-info">
      <div class="bm-hl-cm-book-name">{{ copiesModalBook?.bookName }}</div>
      <div class="bm-hl-cm-book-meta">
        <span class="bm-hl-code" *ngIf="copiesModalBook?.bookId">{{ copiesModalBook.bookId }}</span>
        <span class="bm-hl-cm-author" *ngIf="copiesModalBook?.authorNames?.length">
          {{ copiesModalBook.authorNames.join(', ') }}
        </span>
      </div>
    </div>
    <div class="bm-hl-stats">
      <span class="bm-hl-stat bm-hl-stat-c" title="At Center">⌂ {{ copiesModalBook?.available }}</span>
      <span class="bm-hl-stat bm-hl-stat-m" title="Issued">⇌ {{ copiesModalBook?.issued }}</span>
      <span class="bm-hl-stat bm-hl-stat-t" title="Total">&#x2022; {{ copiesModalBook?.totalCopies }}</span>
    </div>
  </div>

  <div class="bm-hl-cm-body">

    <div class="bm-hl-cm-loading" *ngIf="copiesModalLoading">
      <div class="spinner-border spinner-border-sm text-primary"></div>
      <span>Loading copies…</span>
    </div>

    <div class="alert alert-danger py-2 px-3 small m-3" *ngIf="!copiesModalLoading && copiesModalError">
      <i class="pe-7s-attention me-1"></i>{{ copiesModalError }}
    </div>

    <div class="bm-hl-no-copies text-muted small"
         *ngIf="!copiesModalLoading && !copiesModalError && copiesModalBook?.copies?.length === 0">
      No inventory copies found for this book.
    </div>

    <table class="table table-sm bm-hl-copies-table mb-0"
           *ngIf="!copiesModalLoading && copiesModalBook?.copies?.length > 0">
      <thead>
        <tr><th>Sr No.</th><th>Status</th><th>Location</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let copy of copiesModalBook?.copies" [class]="copyRowClass(copy.status)">
          <td class="bm-hl-srno">{{ copy.bookSrNo }}</td>
          <td>
            <span class="bm-hl-badge" [ngClass]="'bm-hl-badge-' + copy.status">
              {{ copyStatusLabel(copy.status) }}
            </span>
          </td>
          <td class="bm-hl-location">{{ copy.location }}</td>
        </tr>
      </tbody>
    </table>

  </div>

</div>

<!-- ── Book History Modal ──────────────────────────────────── -->
<div *ngIf="showHistory"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background:rgba(0,0,0,.5);z-index:1055;"
     (click)="closeHistory()">
  <div class="card shadow-lg" style="width:820px;max-width:95vw;max-height:85vh;display:flex;flex-direction:column;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="card-header d-flex align-items-center justify-content-between py-3">
      <div>
        <i class="pe-7s-clock me-2 text-info"></i>
        <span class="fw-bold">Issue / Return History</span>
        <span class="text-muted ms-2 small">{{ historyTitle }}</span>
      </div>
      <button class="btn-close" (click)="closeHistory()"></button>
    </div>
    <div class="card-body p-0 overflow-auto">
      <div class="text-center py-5" *ngIf="historyLoading">
        <div class="spinner-border text-info"></div>
        <p class="mt-2 text-muted small">Loading history…</p>
      </div>
      <div class="text-center py-5 text-muted" *ngIf="!historyLoading && historyData.length === 0">
        <i class="pe-7s-clock" style="font-size:2.5rem;opacity:.4"></i>
        <p class="mt-2 small">No transaction history found.</p>
      </div>
      <table class="table table-hover table-bordered mb-0" *ngIf="!historyLoading && historyData.length > 0">
        <thead class="table-light sticky-top">
          <tr><th>#</th><th>Event</th><th>Member</th><th>Serial No.</th><th>Date</th><th>Time</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of historyData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <span class="badge" [class.bg-primary]="row.event === 'issued'" [class.bg-success]="row.event === 'received'">
                {{ row.event === 'issued' ? 'Issued' : 'Received' }}
              </span>
            </td>
            <td>{{ row.memberName }}</td>
            <td><code>{{ row.bookSrNo || '—' }}</code></td>
            <td>{{ row.date | appDate }}</td>
            <td>{{ row.date | date:'hh:mm a' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center py-2 text-muted small border-top" *ngIf="!historyLoading && historyData.length > 0">
        {{ historyData.length }} record{{ historyData.length === 1 ? '' : 's' }}
      </div>
    </div>
  </div>
</div>
